import * as React from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ClassicReenrollmentPageViewFilterRenderer = ({
  reEnrollmentTriggerSet
}) => {
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: reEnrollmentTriggerSet[0].pageViewTriggerType === 'PARTIAL_URL' ? 'flow-doctor-lib.reEnrollmentTriggerSets.pageView.partialUrl' : 'flow-doctor-lib.reEnrollmentTriggerSets.pageView.fullUrl',
    options: {
      pageId: reEnrollmentTriggerSet[0].id,
      urlName: reEnrollmentTriggerSet[0].name
    }
  });
};
export default ClassicReenrollmentPageViewFilterRenderer;